import React from 'react';

import { useRecordContext, TextField } from 'react-admin';

import { Box, Grid, Typography } from '@mui/material';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { FirstNameParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Förnamn',
  [languages.EN]: 'First name',
  [languages.DE]: 'Vorname',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const FirstName = ({ extraParameters }: { extraParameters?: FirstNameParameters }) => {
  const record = useRecordContext();
  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="firstName"
      datapoint={conflictFields.FIRST_NAME}
      identificationInfo={undefined}
    >
      <ValueField />
    </Answer>
  );
};

FirstName.ValueField = ValueField;

FirstName.Nested = ({ source, extraParameters }: {
  source?: string;
  extraParameters?: FirstNameParameters;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const record = useRecordContext();
  const language = record?.language as Languages;
  const sx = get(record, 'sx', {});

  return (
    <Grid
      size={{
        xs: 12,
        md: 3,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="label">{extraParameters?.label ?? CONTENT[language]}</Typography>
        <TextField
          source={source ?? 'firstName'}
          emptyText="-"
          sx={sx}
        />
      </Box>
    </Grid>
  );
};

export default FirstName;
